import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What the Clients Users tab still reads from the workspace: the client users list, its loader and filters (the shared Clients toolbar drives them), the Create / Edit User popup and the shared Clients page tab.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmClientsUsersHost = Pick<
  PmWorkspaceComponent,
  | 'clearClientsUsersSelection'
  | 'clientUserDateCreatedLabel'
  | 'clientUserLastLoginLabel'
  | 'clientsClientUserRows'
  | 'clientsContactsLoading'
  | 'clientsCreateClientUserDraft'
  | 'clientsCreateClientUserModalOpen'
  | 'clientsEditClientUserContactId'
  | 'clientsEditClientUserLoading'
  | 'clientsEditClientUserLoginName'
  | 'clientsSwitchLoading'
  | 'clientsUsersActionMenuRowKey'
  | 'clientsUsersBulkDeleteConfirmOpen'
  | 'clientsUsersBulkStatusDraft'
  | 'clientsUsersFilterStatuses'
  | 'clientsUsersFilterUserTypes'
  | 'clientsUsersFilteredRows'
  | 'clientsUsersFilteredTotalCount'
  | 'clientsUsersGridPageSizeMenuOpen'
  | 'clientsUsersPageNumber'
  | 'clientsUsersPageSize'
  | 'clientsUsersRowCheck'
  | 'clientsUsersViewMode'
  | 'closeClientsUsersActionMenu'
  | 'copyChValue'
  | 'createClientUserConfirmPassword'
  | 'createClientUserConfirmPasswordVisible'
  | 'createClientUserContactChoice'
  | 'createClientUserLaunchSource'
  | 'createClientUserPasswordVisible'
  | 'effectiveDirectoryActingUserIdForContacts'
  | 'effectiveDirectoryParentUserId'
  | 'ensureClientUsersFirmTotalCount'
  | 'ensureClientsAddMasterDataLoaded'
  | 'lastClientsUsersFirmCountKey'
  | 'lastClientsUsersHydrationLoadKey'
  | 'loadDirectoryClientUsers'
  | 'profile'
  | 'stopPropAllowSpaceInFields'
>;

export const PM_CLIENTS_USERS_HOST = new InjectionToken<PmClientsUsersHost>('PmClientsUsersHost');
